import { flow, uniq, get, tap, map, curry, keyBy, forEach, find } from 'lodash/fp';
import { flowAsync } from '@gcc/nodash';
import { renameWindowLabel } from '../../api/designBuilder';
import renameWindowItem from './renameWindowItem';
import loaded from '../loaded';
import loading from '../loading';
import globalError from '../globalError';

export default (sourceItemId, targetItemIds) => (dispatch, getState) => {
  dispatch(loading());

  const { estimateBuilder } = getState();

  const items = get('entities.items.byId', estimateBuilder);
  const containers = get('entities.containers.byId', estimateBuilder);

  const targetItems = map(get(curry.placeholder, items), targetItemIds);

  const containerIds = flow(map('containerId'), uniq)(targetItems);
  const targetContainers = flow(map(get(curry.placeholder, containers)), keyBy('containerId'))(containerIds);

  const itemsWithContainer = map(
    item => ({
      ...item,
      container: targetContainers[item.containerId],
    }),
    targetItems,
  );

  const itemsToUpdate = [];

  const updateItemWindowLabels = flowAsync(forEach((item) => {
    const findWindowName = find(a => a.name === 'Window Name', item.itemProduct.attributes);
    const windowName = findWindowName ? findWindowName.value : item.label;
    itemsToUpdate.push({
      designId: item.designId,
      itemId: item.itemId,
      newLabel: windowName,
    });
  }));

  return updateItemWindowLabels(itemsWithContainer)
    .then(() => dispatch(renameWindowItem(itemsToUpdate)))
    .then(() => renameWindowLabel(itemsToUpdate))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
